module.exports = __webpack_public_path__ + "static/media/rainy.svg.cc907c35.png";